
import AppRouter from './router'
import { useTabVisibility } from './hooks/common/useTabVisibility'
import { DeviceProvider } from './hooks/common/DeviceContext'

function App() {
  // Reload the page if user returns after being away for 25 minutes
  useTabVisibility(25);

  return (
    <DeviceProvider>
      <AppRouter/>
    </DeviceProvider>
  )
}

export default App